module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'datepicker-field ' + (_vm.isSelected ? 'selected' : ''),
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_c('span', {
    staticClass: "prefix"
  }, [_c('icon', {
    attrs: {
      "name": "calendar",
      "scale": 1.6
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n    " + _vm._s(_vm.formattedValue) + "\n  ")]), _vm._v(" "), _c('span', {
    staticClass: "suffix"
  }, [(!_vm.isSelected) ? _c('icon', {
    attrs: {
      "name": "chevron-down",
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSelected) ? _c('icon', {
    attrs: {
      "name": "circle-green-minus",
      "scale": 1.5
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dd00418"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/DatepickerButton.vue
// module id = 950
// module chunks = 0